import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 9.774a.553.553 0 0 1-.422-.17L4.582 6.606a.48.48 0 0 1-.142-.348.47.47 0 0 1 .142-.354.48.48 0 0 1 .351-.145q.207 0 .352.145L8 8.62l2.715-2.715a.48.48 0 0 1 .348-.142.47.47 0 0 1 .355.142.48.48 0 0 1 .145.35.48.48 0 0 1-.145.352L8.422 9.603a.55.55 0 0 1-.422.17" }, null, -1)
  ])))
}
export default { render: render }